'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _main = require('../../main');

var _main2 = _interopRequireDefault(_main);

var _tile = require('../../../../atoms/tile');

var _tile2 = _interopRequireDefault(_tile);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'drawer-tiles';

var isIE = function isIE() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1 || ua.indexOf('Edge') > -1;
};

var DrawerTiles = function (_InteractiveTiles) {
  _inherits(DrawerTiles, _InteractiveTiles);

  function DrawerTiles(props) {
    _classCallCheck(this, DrawerTiles);

    var _this = _possibleConstructorReturn(this, (DrawerTiles.__proto__ || Object.getPrototypeOf(DrawerTiles)).call(this, props));

    _this.renderTiles = _this.renderTiles.bind(_this);
    _this.callback = _this.callback.bind(_this);
    _this.scrollToModule = _this.scrollToModule.bind(_this);

    _this.state = {
      drawerOpen: false,
      selectedIndex: null
    };
    return _this;
  }

  _createClass(DrawerTiles, [{
    key: 'renderTiles',
    value: function renderTiles(tiles, columns, selectedItemTheme, callback) {
      var config = this.props.config;
      var selectedIndex = this.state.selectedIndex;


      if (tiles.length) {
        var markup = [];
        var bootstrapClass = void 0;

        switch (columns) {
          case 2:
            {
              bootstrapClass = 'col-xs-12 col-md-6';break;
            }
          case 3:
            {
              bootstrapClass = 'col-xs-12 col-md-6 col-lg-4';break;
            }
          case 4:
            {
              bootstrapClass = 'col-xs-12 col-md-6 col-lg-3';break;
            }
          default:
        }

        for (var idx = 0; idx < tiles.length; idx += 1) {
          markup.push(_react2.default.createElement(
            'div',
            { key: config.id + '-' + idx, className: bootstrapClass },
            _react2.default.createElement(_tile2.default, _extends({}, tiles[idx], {
              theme: selectedItemTheme,
              callback: callback,
              index: idx,
              id: config.id,
              active: selectedIndex === idx
            }))
          ));
        }
        return markup;
      }
      return null;
    }
  }, {
    key: 'calculateScrollTo',
    value: function calculateScrollTo() {
      var newWindowWidth = this.organismRef.ownerDocument.defaultView.innerWidth || this.organismRef.ownerDocument.documentElement.clientWidth || this.organismRef.ownerDocument.body.clientWidth;

      return newWindowWidth > _breakpoints2.default.large ? this.organismRef.offsetTop : this.organismRef.offsetTop + this.organismRef.clientHeight;
    }
  }, {
    key: 'scrollToModule',
    value: function scrollToModule() {
      if (window) {
        var scrollToPx = this.calculateScrollTo();

        if (isIE()) {
          window.scrollTo(0, scrollToPx);
        } else {
          window.scroll({ top: scrollToPx, left: 0, behavior: 'smooth' });
        }
      }
    }
  }, {
    key: 'callback',
    value: function callback(index, url, target, fpti) {
      var callback = this.props.callback;
      var _state = this.state,
          drawerOpen = _state.drawerOpen,
          selectedIndex = _state.selectedIndex;


      if (drawerOpen) {
        if (selectedIndex === index) {
          this.setState({
            drawerOpen: false,
            selectedIndex: null
          });
        } else {
          this.setState({
            selectedIndex: index
          });
          this.scrollToModule();
        }
      } else {
        this.setState({
          drawerOpen: true,
          selectedIndex: index
        });
        this.scrollToModule();
      }

      callback(index, url, target, fpti);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state2 = this.state,
          drawerOpen = _state2.drawerOpen,
          selectedIndex = _state2.selectedIndex;
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var id = config.id,
          columns = config.columns;
      var theme = config.theme,
          selectedItemTheme = config.selectedItemTheme;

      theme = theme || 'theme-background-color-green';
      selectedItemTheme = selectedItemTheme || 'theme-background-color-blue-alt';

      var sectionClasses = (0, _classnames2.default)('interactive-tiles-organism ' + ORGANISM_NAME + '-organism', 'center-block text-xs-center', theme, className);
      var headline = content.headline,
          paragraph = content.paragraph,
          tiles = content.tiles,
          footer = content.footer;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'section',
          {
            id: id,
            ref: function ref(c) {
              _this2.organismRef = c;
            },
            className: sectionClasses,
            'data-building-block': 'organism'
          },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              this.renderHeadline(headline),
              this.renderParagraph(paragraph)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              this.renderTiles(tiles, columns, selectedItemTheme, this.callback)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              this.renderFooter(footer)
            )
          )
        ),
        drawerOpen && selectedIndex !== null && _react2.default.createElement(
          'section',
          { className: ORGANISM_NAME + '__drawer' },
          _react2.default.createElement('div', { className: ORGANISM_NAME + '__drawer__color-band ' + selectedItemTheme }),
          this.props.children[selectedIndex]
        )
      );
    }
  }]);

  return DrawerTiles;
}(_main2.default);

exports.default = DrawerTiles;


DrawerTiles.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-purple', 'theme-background-color-pink']),
    columns: _propTypes2.default.oneOf([2, 3, 4]).isRequired,
    selectedItemTheme: _propTypes2.default.oneOf(['theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-purple', 'theme-background-color-pink'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    tiles: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      content: _propTypes2.default.shape({
        img: _propTypes2.default.shape({
          src: _propTypes2.default.string.isRequired,
          alt: _propTypes2.default.string.isRequired
        }),
        text: _propTypes2.default.string,
        fpti: _propTypes2.default.string
      })
    })),
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string,
  callback: _propTypes2.default.func
};

DrawerTiles.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/interactive-tiles/drawer/jsx/DrawerTiles.js
// module id = 1108
// module chunks = 4